module.exports = __webpack_public_path__ + "static/media/laban_v2.d894b7c4.png";